import { isEmpty } from "lodash";

export function getDeploymentStatuses() {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/deployment_status/list',
            dataType: 'json',
            data: {
                pagination_token: pagination_token
            }
        }).promise().then(deployment_statuses_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in deployment_statuses_json.data.deployment_statuses) {
                results.push({
                    id: deployment_statuses_json.data.deployment_statuses[index].id,
                    name: deployment_statuses_json.data.deployment_statuses[index].name,
                    status_color: deployment_statuses_json.data.deployment_statuses[index].status_color,
                });
            }

            // Break out of this recursive loop if we've found everything
            if (deployment_statuses_json.data.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(deployment_statuses_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching deployment statuses. Please try again.');
        });
    };

    return execute_query();
}

export function getDeploymentStatus(deployment_status_id) {
    if (isEmpty(deployment_status_id)) {
        return Promise.resolve({
            id: null
        });
    } else {
        // Issue the request to the describe endpoint
        return $.ajax({
            url: '/api/deployment_status/describe',
            dataType: 'json',
            data: {
                id: deployment_status_id
            }
        }).promise().then(deployment_status_json => {
            return {
                id: deployment_status_json.data.id,
                text: deployment_status_json.data.name,
                name: deployment_status_json.data.name,
                status_color: deployment_status_json.data.status_color,
                type: deployment_status_json.data.type
            };
        }).catch(error => {
            console.error('Error fetching deployment status:', error);
            throw new Error('Error fetching deployment status. Please try again.');
        });
    }
}